import { Text, VSpacer } from '@/components/DesignSystem';
import { PointsAuditEndpoint } from '@api/endpoints';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

type RevertScope = NonNullable<PointsAuditEndpoint.RevertPreview.Response['scope']>;

/** Everyone the change reached when it was made: a revert can change no one else. */
export const RevertScopeList = ({ scope }: { scope: RevertScope }) => {
  const { t } = useTranslation();
  const nameOf = (farmer: RevertScope['farmers'][number]) => (
    farmer.businessName || farmer.name || farmer.externalId || farmer.id
  );

  return (
    <Stack data-testid="revert-scope">
      <Text category="label-medium">{t($ => $.pointsAudit.revert.scopeTitle)}</Text>
      <VSpacer size="2" />
      {scope.farmers.map((farmer) => (
        <Text category="body-medium" key={farmer.id} testID={`revert-scope-farmer-${farmer.id}`}>
          {farmer.externalId
            ? t($ => $.pointsAudit.revert.scopeFarmer, {
              externalId: farmer.externalId,
              name: nameOf(farmer),
            })
            : nameOf(farmer)}
        </Text>
      ))}
      {scope.farmerCount > scope.farmers.length && (
        <Text category="body-medium" testID="revert-scope-more">
          {t($ => $.pointsAudit.revert.scopeMore, {
            count: scope.farmerCount - scope.farmers.length,
          })}
        </Text>
      )}
      {scope.accountGroups.map((group) => (
        <Text category="body-small" key={group.id} testID={`revert-scope-group-${group.id}`}>
          {t($ => $.pointsAudit.revert.scopeGroup, {
            count: group.memberIds.length,
            group: group.externalId ?? group.id,
          })}
        </Text>
      ))}
      <VSpacer size="4" />
    </Stack>
  );
};
